import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import {sanitizeAndRenderHTML as renderHTML} from "../../../../../utils/utils";
import { ButtonGroup, Button, Tag } from "@blueprintjs/core";
import MCQEditForm from "../../../Form/MCQQuestion/EditForm/MCQEditForm";

import "./zoom.css";

class QuestionCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      EditMode: false
    };
    this.toggleMode = () => {
      this.setState({
        EditMode: !this.state.EditMode
      });
    };
  }
  render() {
    var AnswerBlock = [];
    if (this.props.data.answers !== undefined) {
      this.props.data.answers.map((instance, index) =>
        AnswerBlock.push(
          <h5 key={index}>
            {" "}
            {instance.position > 0 ? instance.position : "*"}) &nbsp;{" "}
            {renderHTML(instance.answer)}&nbsp;
            {instance.isCorrect === 1 && (
              <i style={{ color: "green" }} className="fa fa-check " />
            )}
            &nbsp;
            {instance.position > 0 && (
              <i style={{ color: "#dd4837" }} className="fa fa-lock" />
            )}
          </h5>
        )
      );
    }
    // end answer body

    // Answer Body
    const htmlContent = this.props.data.content;
    return (
      <div>
        <MCQEditForm
          onClose={this.toggleMode}
          isOpen={this.state.EditMode}
          data={this.props.data}
          {...this.props}
        />

        <Col sm={12} md={12}>
          <div autoFocus className={"card"} style={{ width: "100%" }}>
            <div className="content">
              <Row>
                <Col sm={12} md={1}>
                  <h3 style={{ padding: "  20px", color: "#474747" }}>
                    {("0" + parseInt(this.props.index + 1, 10)).slice(-2)}
                  </h3>
                </Col>

                <Col sm={12} md={11}>
                  <Row>
                    <Col sm={12}>
                      {/* Question ToolBar------------------- */}
                      <ButtonGroup minimal={true}>
                        <Button icon="edit" onClick={this.toggleMode}>
                          Edit
                        </Button>
                        <Button icon="flow-branch">Clone</Button>
                        <Button icon="trash" intent="danger">
                          Remove
                        </Button>
                      </ButtonGroup>
                      {/* End Question Tool Bar ------------------- */}
                    </Col>
                    <br />
                    <hr />
                    <Col sm={12}>{renderHTML(htmlContent)}</Col>
                  </Row>

                  {this.props.data.otherContent !== null && (
                    <Row>
                      <img
                        className="zoom"
                        style={{
                          border: "1px solid #ddd",
                          border_radius: "4px",
                          width: "100px"
                        }}
                        alt="Question Other Content"
                        src={this.props.data.otherContent}
                      />
                    </Row>
                  )}

                  <Row>
                    <hr />
                    <Col sm={6}>
                      <Row>
                        <Col sm={12} style={{ paddingTop: "4px" }}>
                          <b>Type</b> :
                          {this.props.data.isMultipleSelection === 1 ? (
                            <code>Multiple Selection</code>
                          ) : (
                            <code>Single Selection</code>
                          )}
                        </Col>

                        <Col sm={12} style={{ paddingTop: "4px" }}>
                          <b>Display answer</b> :
                          {this.props.data.numberOfAnswers}
                        </Col>
                        {this.props.data.versionList && (
                          <Col sm={12} style={{ paddingTop: "4px" }}>
                            <b>Compatible Versions </b> :
                            {this.props.data.versionList.split(",").map(
                              (value, index) => {
                                return (
                                  <Tag
                                    style={{ marginRight: "3px" }}
                                    minimal={true}
                                    intent="success"
                                    key={index}
                                  >
                                    {value}
                                  </Tag>
                                );
                              }
                            )}
                          </Col>
                        )}
                      </Row>

                      <Row>
                        <Col md={6} sm={12} style={{ paddingTop: "4px" }}>
                          <b>Created By</b> :{this.props.data.createdBy}
                        </Col>
                        <Col md={6} sm={12} style={{ paddingTop: "4px" }}>
                          <b>Created Date</b> :{this.props.data.createdDate}
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} sm={12} style={{ paddingTop: "4px" }}>
                          <b>Verified By</b> :{this.props.data.verifiedBy}
                        </Col>
                        <Col md={6} sm={12} style={{ paddingTop: "4px" }}>
                          <b>Verified Date</b> :{this.props.data.verifiedDate}
                        </Col>
                      </Row>
                      <Row>
                        {this.props.data.scenarioId && (
                          <Col md={6} sm={12}>
                            <Tag intent="warning">
                              Scenario ID : {this.props.data.scenarioId}
                            </Tag>
                          </Col>
                        )}
                        <Col md={6} sm={12}>
                          {this.props.data.isSample === 1 && (
                            <Tag intent="success">Sample Question</Tag>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={6}>
                      <Row>
                        <p className="category">
                          <b> ID </b>:{this.props.data.id}
                        </p>
                        <p className="category">
                          {" "}
                          <b>CategoryID</b> :{this.props.data.categoryId}
                        </p>
                        <p className="category">
                          {" "}
                          <b>TopicID</b> :{this.props.data.topicId}
                        </p>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div className="footer" style={{ background: "#FFFBE1 " }}>
              <hr />
              <div className="stats" style={{ marginLeft: "40px" }}>
                {AnswerBlock}
              </div>
            </div>
          </div>
        </Col>
      </div>
    );
  }
}

export default QuestionCard;
